var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "4",
        viewBox: "0 0 17 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_51_113214)" } }, [
        _c("path", {
          attrs: {
            d: "M17 1.9803C17 1.29069 16.4429 0.733544 15.7533 0.733544H2.03899C1.34938 0.733544 0.792236 1.29069 0.792236 1.9803C0.792236 2.66991 1.34938 3.22705 2.03899 3.22705H15.7533C16.4429 3.22705 17 2.66991 17 1.9803Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_51_113214" } }, [
          _c("rect", {
            attrs: {
              width: "16.2078",
              height: "3",
              fill: "white",
              transform: "matrix(1 0 0 -1 0.792236 3.5)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }